<div id="playfield">
    <div id="nonogram-root">
        <!-- Filled by javascript -->
    </div>
    <div id="footer">
        <!-- Filled by javascript -->
    </div>
</div>